/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { FormLabel, UnorderedList, ListItem } from 'carbon-components-react';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { ctaEvents } from '@ibm-watson/shared/modules/ia/util/trackers/segment';
import { FormattedMessageWithLink } from '../../../helpers/linkHelpers';
import { TabContent } from '../../common/tabbed-header/TabContent';
import { PhoneIcon } from '../../icons/PhoneIcon';
import { links } from '../links';
import { PhoneNew as messages } from './messages';

export const PhoneSplashPage = () => {
  // Need to wrap the Image so it will be in color and work with TabContent
  const WrappedImageComponent = () => {
    return (
      <div className="Phone__icon--brand">
        <PhoneIcon />
      </div>
    );
  };

  const [firstRender, setFirstRender] = useState(true);

  if (firstRender) {
    ctaEvents.phoneNewViewed({
      category: 'Phone'
    });
    setFirstRender(false);
  }

  return (
    <TabContent
      title={
        <>
          <div>
            <FormattedMessage {...messages.titleOne} />
          </div>
          <div>
            <FormattedMessage {...messages.titleTwo} />
          </div>
        </>
      }
      ImageComponent={WrappedImageComponent}>
      <div className="TabContent__body-content">
        <div className="TabContent__subtitle">
          <FormattedMessage {...messages.subtitleOne} />
        </div>
        <div className="TabContent__spacer16" />
        <div className="TabContent__subtitle Phone__Note--bold">
          <FormattedMessage {...messages.pricingNote} />
        </div>
        <div className="TabContent__spacer8" />
        <div className="TabContent__description">
          <h4 className="productive-heading-02">
            <FormattedMessage {...messages.instructions} />
          </h4>
        </div>
        <div className="TabContent__body">
          <FormLabel>
            <FormattedMessage {...messages.instructionsDescription} />
          </FormLabel>
          <div className="PhoneNew__body-indent">
            <UnorderedList className="TabContent__subtitle">
              <ListItem>
                <FormattedMessage {...messages.instructionsItemTwo} />
              </ListItem>
              <ListItem>
                <FormattedMessage {...messages.instructionsItemThree} />
              </ListItem>
              <ListItem>
                <FormattedMessage {...messages.instructionsItemFour} />
              </ListItem>
              <ListItem>
                <div className="TabContent__link-larger-text">
                  <FormattedMessageWithLink
                    url={links.customDeployment}
                    {...messages.instructionsItemFive}
                  />
                </div>
              </ListItem>
            </UnorderedList>
          </div>
        </div>
        <div className="TabContent__spacer8" />
        <div className="TabContent__subtitle TabContent__link-larger-text">
          <FormattedMessageWithLink
            url={links.learnMoreOtherSipLink}
            {...messages.instructionsLinkByoSipTrunk}
          />
        </div>
        <div className="TabContent__subtitle TabContent__link-larger-text">
          <FormattedMessageWithLink
            url={links.learnMorePhoneIntegLink}
            {...messages.instructionsLinkLearnMore}
          />
        </div>
      </div>
    </TabContent>
  );
};
